import { live, LiveComponentReact, LiveController, LiveControllerReact, ReactRegistry } from "@camertron/live-component"
import { useCallback, useEffect, useMemo, useState } from "react"

type DigitProps = {
  number: number
}

const DIGIT_MAP = {
  0: "zero",
  1: "one",
  2: "two",
  3: "three",
  4: "four",
  5: "five",
  6: "six",
  7: "seven",
  8: "eight",
  9: "nine"
};

const Digit = ({ number }: DigitProps) => {
  return (
    <div className={`digit ${DIGIT_MAP[number]}`}>
      <span className="d1"></span>
      <span className="d2"></span>
      <span className="d3"></span>
      <span className="d4"></span>
      <span className="d5"></span>
      <span className="d6"></span>
      <span className="d7"></span>
    </div>
  );
};

type StopwatchProps = {
  elapsed_msecs?: number
  running?: boolean
  on_elapsed?: (msecs: number) => void
}

const Stopwatch = ({elapsed_msecs: init_elapsed_msecs = 0, running = false, on_elapsed, ...rest}: StopwatchProps) => {
  const [elapsed_msecs, set_elapsed_msecs] = useState(init_elapsed_msecs);
  const [intervalId, setIntervalId] = useState<number | null>(null);

  const tick = useCallback(() => {
    if (!running) return;
    set_elapsed_msecs(prev => {
      const new_elapsed = prev + 100;
      on_elapsed?.(new_elapsed);
      return new_elapsed
    });
  }, [running]);

  useEffect(() => {
    if (running && !intervalId) {
      /* @ts-ignore */
      setIntervalId(setInterval(tick, 100));
    } else {
      if (intervalId) {
        clearInterval(intervalId);
        setIntervalId(null);
      }
    }
  }, [running]);

  const elapsed_secs = useMemo(() => Math.floor(elapsed_msecs / 1000), [elapsed_msecs]);
  const minutes = useMemo(() => Math.floor(elapsed_secs / 60), [elapsed_secs]);
  const seconds = useMemo(() => elapsed_secs % 60, [elapsed_secs]);
  const seconds_tens = useMemo(() => Math.floor(seconds / 10), [seconds]);
  const seconds_ones = useMemo(() => seconds % 10, [seconds]);
  const ms_tens = useMemo(() => Math.floor(Math.floor((elapsed_msecs % 1000) / 10) / 10), [elapsed_msecs]);

  return (
    <div className="stopwatch" {...rest}>
      <Digit number={minutes} />
      <div className="dots"></div>
      <Digit number={seconds_tens} />
      <Digit number={seconds_ones} />
      <div className="decimal"></div>
      <Digit number={ms_tens} />
    </div>
  );
}

ReactRegistry.register_component("Stopwatch", Stopwatch);

@live("Stopwatch")
export class StopwatchComponent extends LiveController {
  public elapsed_msecs: number = 0;

  start() {
    // @TODO: this sucks, let's allow render() to accept props
    this.react_component.props.running = true;
    this.react_component?.render();
    // this.render({ running: true });
  }

  stop() {
    // @TODO: this sucks, let's allow render() to accept props
    this.react_component.props.running = false;
    this.react_component.props.elapsed_msecs = this.elapsed_msecs;
    this.react_component?.render();
    // this.render({ running: false });
  }

  on_elapsed(msecs: number) {
    this.elapsed_msecs = msecs;
  }

  // @TODO: this also sucks, let's make targets easier to add via props
  get react_component(): LiveControllerReact | null {
    const component = this.element.querySelector("live-component-react") as LiveComponentReact | null;
    return component?._controller as LiveControllerReact | null;
  }
}
